import { swSettings } from "app/common/services/swSettings";
import { HasWorkspaceTrialPermission } from "app/pages/workspace/common/workspacesUtils";
import { getWsConfigFromState } from "app/pages/workspace/config/stateToWsConfigMap";
import { hasWorkSpacesPermission } from "app/services/Workspaces.service";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { isAvailable } from "./pageClaims";

export function canNavigate(toState: string | { name?: string }, toParams: FixmeType): boolean {
    toState = typeof toState === "string" ? proNavigator.getState(toState) : toState;
    // Important notice : we do not want to apply the same permissions to trial user and workspace user
    const workspaceEnabled = hasWorkSpacesPermission() && !HasWorkspaceTrialPermission();
    const wsConfig = getWsConfigFromState(toState, toParams);
    const originComponent = proNavigator.getConfigIdFromStateConfig(toState, toParams);

    const isSolutions2 = swSettings.user.hasSolution2;
    // probably not the best solution to target MR/DM packages like that but what could I do

    const componentId = ((workspaceEnabled || isSolutions2) && wsConfig && wsConfig.wsComponent) || originComponent;
    const component = swSettings.components[componentId];
    return isAvailable(component);
}
